export default {
  LOCAL_ELECTION_TYPE: {
    COUNTY_PARLIAMENT: 'CountyParliament',
    COUNTY_MAJOR: 'CountyMajor',
    MUNICIPALITY_PARLIAMENT: 'MunicipalityParliament',
    MUNICIPALITY_MAJOR: 'MunicipalityMajor',
  },
};
